window.addEventListener('DOMContentLoaded', function() {
    const urlParams = new URLSearchParams(window.location.search);
    const params_to_cap = ['reason_for_abandoned_cart', 'email'];
    const form_ele = document.querySelector('form[class="ml-block-form"]');
    console.log('hi');
    // Check if form exists
    if (!form_ele) {
        console.warn('Form with class "ml-block-form" not found');
        return;
    }
    
    const values_obj = {};
    params_to_cap.forEach(param => {
        const value = urlParams.get(param);
        if (value) {
            values_obj[param] = value;
        }
    });
    
    const form_ele_items = form_ele.querySelectorAll('input, select, textarea');
    form_ele_items.forEach(item => {
        const item_name = item.name.replace('fields[', '').replace(']', '');
        const item_value = item.value;
        if (values_obj[item_name]) {
            if (item.tagName === 'SELECT') {
                // Find options
                const options = item.querySelectorAll('option');
                options.forEach(option => {
                    if (option.value === values_obj[item_name]) {
                        option.selected = true;
                    }
                });
            } else {
                item.value = values_obj[item_name];
            }
        }
    });
});